module.exports = __webpack_public_path__ + "img/effects-4.2cbbd6ae.png";